export default "__VITE_PUBLIC_ASSET__3f6fbe7a__"